import { SuccessorAccountEntry } from "hooks/successors/GetMySuccessorAccountsHook";
import "./SuccessorOwnerSelector.scss";

interface Props {
  owners: SuccessorAccountEntry[];
  selectedOwnerUuid: string | null;
  onSelect: (uuid: string | null) => void;
}

function pluralAssets(count: number): string {
  if (count === 1) return "1 aktywo";
  if (count >= 2 && count <= 4) return `${count} aktywa`;
  return `${count} aktywów`;
}

const SuccessorOwnerSelector = ({ owners, selectedOwnerUuid, onSelect }: Props) => {
  return (
    <div className="successor-owner-selector">
      <p className="successor-owner-selector__label">
        Wybierz właściciela aktywów, aby zobaczyć swoje aktywa lub aktywa dostępne w ramach sukcesji
      </p>
      <div className="successor-owner-selector__tiles">
        <button
          className={`successor-owner-selector__tile${selectedOwnerUuid === null ? " successor-owner-selector__tile--active" : ""}`}
          onClick={() => onSelect(null)}
        >
          <span className="successor-owner-selector__tile-name">Moje Aktywa</span>
          <span className="successor-owner-selector__tile-sub">Twoje aktywa osobiste</span>
        </button>

        {owners.map((owner) => (
          <button
            key={owner.ownerUuid}
            className={`successor-owner-selector__tile${selectedOwnerUuid === owner.ownerUuid ? " successor-owner-selector__tile--active" : ""}`}
            onClick={() => onSelect(owner.ownerUuid)}
          >
            <span className="successor-owner-selector__tile-name">{owner.ownerName}</span>
            <span className="successor-owner-selector__tile-sub">
              {pluralAssets(owner.investmentsCount)}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SuccessorOwnerSelector;
